// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidenav[data-v-1b7698f0]{display:flex;height:100%}.sidenav-list[data-v-1b7698f0]{flex:1}.sidenav-list[data-v-1b7698f0],.sidenav-list-item[data-v-1b7698f0]{display:flex;flex-direction:column;height:100%}.sidenav-list-item[data-v-1b7698f0]{justify-content:space-between}.sidenav .list-content[data-v-1b7698f0]{display:flex;flex-direction:column;row-gap:24px}.sidenav ul[data-v-1b7698f0]{padding-left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
